import React from 'react';
import queryString from 'query-string';
import PrivateRoute from 'PrivateRoutes';
import { ContactPrivateInfo } from './components';


const contactList = ({ location }) => {
  const queryParams = queryString.parse(location.search);
  
  return <ContactPrivateInfo contactInfoId={queryParams.id} contactId={queryParams.cid} /> ;
};

const routes = () => (
  <PrivateRoute
    exact
    path="/settings/contact/contactInfo"
    component={contactList}
  />
);

// const routes = () => (
//   <PrivateRoute exact path="/settings/contact/contactInfo" component={ContactPrivateInfo} />
// );

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/ContactPrivateInfo/routes.js